define('views/modules/template/list/template-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/list/list',
    'views/modules/template/list/template-list-item',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VList,
    VTemplateListItem
) {

    var VTemplateList = VList.extend({
        item: VTemplateListItem,

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['profile', 'group']));
        },

        selectTemplateItem: function(model) {
            for (var i = 0; i < this.childViews.length; i++) {
                if (this.childViews[i].model.get("_id") === model.get("_id")) {
                    this.childViews[i].$el.addClass("active");
                    break;
                  }
            }
        },
    });

    return VTemplateList;

});

